'use strict';

import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { doAuthenticate } from '../../data/service/libreview/actions';
import { withPageBase } from '../../components/PageBase';
import Loader from '../../components/Loader';
import queryString from 'query-string';

/*
 * See omatays-service/src/main/resources/tayspolku/README.md.
 * */

const LibreviewRedirect = (props) => {
  const { libreview, doAuthenticate } = props;

  useEffect(() => {
    const parsed = queryString.parse(props.location.search);
    doAuthenticate(parsed.code);
  }, []);

  return (
    <>
      {libreview.authentication.isSuccessful !== null && (
        <FormattedMessage
          id={`libreview.Redirect.js.message.authentication.${libreview.authentication.isSuccessful}`}
        >
          {(txt) => <p>{txt}</p>}
        </FormattedMessage>
      )}
      {libreview.authentication.isFetching && <Loader />}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    libreview: state.services.libreview,
  };
};

export default withPageBase(
  connect(mapStateToProps, { doAuthenticate })(LibreviewRedirect),
  { title: '' }
);
